export function Pagination({ page, totalPages, onChange }) {
   if (totalPages <= 1) return null;
   return (
      <div className="flex items-center justify-center gap-1 pt-1!">
         <button
            type="button"
            onClick={() => onChange(page - 1)}
            disabled={page === 1}
            className="px-2! py-0.5! text-xs rounded border! border-gray-200! bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
         >
            ‹
         </button>
         {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <button
               type="button"
               key={p}
               onClick={() => onChange(p)}
               className={`px-2! py-0.5! text-xs rounded border! transition ${p === page
                  ? "bg-blue-500 text-white border-blue-500!"
                  : "border-gray-200! bg-white hover:bg-gray-50 text-(--textColor)"
                  }`}
            >
               {p}
            </button>
         ))}
         <button
            type="button"
            onClick={() => onChange(page + 1)}
            disabled={page === totalPages}
            className="px-2! py-0.5! text-xs rounded border! border-gray-200! bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
         >
            ›
         </button>
      </div>
   );
}
